module.exports = __webpack_public_path__ + "img/blog-10.c9f26df8.jpg";